import { COLORS, FONT_FAMILY, SIZES } from '@static/styles';
import { createFontStyle } from '@utils/createFontStyle';
import { collision } from '@utils/collision';
import { GameConfiguratorSingleton } from '@services/GameConfiguratorSingleton';
var DefenderSelectBoxes = /** @class */ (function () {
    function DefenderSelectBoxes(defendersData) {
        var _this = this;
        this._picSize = 32; // image size in sprite is 32px
        this._defenderImageSize = 60;
        this._boxSize = 80;
        this._boxPadding = 10;
        this._boxMargin = 10;
        this.drawDefendersSelectBox = function (defenderData, index, selectedDefenderType) {
            var boxPosition = _this._gameConfigurator.canvasWidth -
                (_this._boxSize + _this._boxMargin) * (index + 1);
            var mouse = {
                x: boxPosition,
                y: _this._boxPadding,
                width: _this._boxSize,
                height: _this._boxSize,
            };
            if (_this._defendersSelectBoxMouses.length < index + 1) {
                _this._defendersSelectBoxMouses.push(mouse);
            }
            _this._gameConfigurator.context.fillStyle = COLORS.defenderSelectorColor;
            _this._gameConfigurator.context.fillRect(boxPosition, _this._boxPadding, _this._boxSize, _this._boxSize);
            _this._gameConfigurator.context.fillStyle = COLORS.textColor;
            _this._gameConfigurator.context.font = createFontStyle(SIZES.costSize, FONT_FAMILY);
            _this._gameConfigurator.context.textAlign = 'right';
            _this._gameConfigurator.context.textBaseline = 'middle';
            _this._gameConfigurator.context.fillText(defenderData.cost.toString(), boxPosition + _this._boxSize - _this._boxPadding, _this._boxPadding * 2);
            _this._gameConfigurator.context.drawImage(defenderData.image, 0, 0, _this._picSize, _this._picSize, boxPosition, _this._boxPadding * 2, _this._defenderImageSize, _this._defenderImageSize);
            if ((_this._gameConfigurator.mouse.x &&
                _this._gameConfigurator.mouse.y &&
                collision(mouse, _this._gameConfigurator.mouse)) ||
                defenderData.type === selectedDefenderType) {
                _this._gameConfigurator.context.strokeStyle = COLORS.textColor;
                _this._gameConfigurator.context.lineWidth = 3;
                _this._gameConfigurator.context.strokeRect(boxPosition, _this._boxPadding, _this._boxSize, _this._boxSize);
            }
        };
        this._gameConfigurator = GameConfiguratorSingleton.getInstance();
        this._defendersData = defendersData;
        this._defendersSelectBoxMouses = [];
    }
    DefenderSelectBoxes.prototype.draw = function (selectedDefenderType) {
        var _this = this;
        this._defendersData.forEach(function (defenderData, index) {
            return _this.drawDefendersSelectBox(defenderData, index, selectedDefenderType);
        });
    };
    Object.defineProperty(DefenderSelectBoxes.prototype, "defendersSelectBoxMouses", {
        get: function () {
            return this._defendersSelectBoxMouses;
        },
        enumerable: false,
        configurable: true
    });
    return DefenderSelectBoxes;
}());
export { DefenderSelectBoxes };
